// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultRowMobile_wrapper__1Fa8G","favouritesBtn":"ResultRowMobile_favouritesBtn__jFlrk"};